import { z } from "zod";

export const GrantAccessSchema = z.object({
  role: z.string(),
  password: z.string().min(6, "Passoword Must be minimum 6 characters"),
})